import Controller from '../../shared/logic/Controller';
import Label from '../../shared/model/label/Label';

export const className = 'Labels';
export const dependenciesRunInState = '--NA';
export const fields = {
  list: ['id', 'name', 'color']
};

export default class Labels extends Controller {
  run = async (dependencies, dependenciesForAngular) => {
    const isInRunnableState = await this.init(
      [],
      dependencies,
      dependenciesForAngular,
      dependenciesRunInState
    );
    if (!isInRunnableState) {
      return;
    }
    this.Scope.set(
      {
        isReady: { Labels: true }
      },
      true
    );
  };

  constructor(
    $rootScope,
    $scope,
    $state,
    $timeout,
    webpage,
    eventService,
    authenticationService
  ) {
    'ngInject';

    const angularDependencies = [
      $rootScope,
      $scope,
      $state,
      $timeout,
      webpage,
      eventService,
      authenticationService
    ];
    super(angularDependencies, {
      Storage: {
        Table: className
      },
      Scope: {
        Defaults: {
          Name: className
        }
      },
      Data: {
        Model: Label,
        ModelName: className,
        Requests: {
          available: {
            url: '/api/v1/labels/available/',
            query: {
              orderBy: 'name',
              coerceTo: 'string',
              isDescending: false
            }
          }
        }
      }
    });

    this.run();
  }
}
